import { useMutation } from '@tanstack/react-query';
import { profileApi } from '~/lib/request';

function useSsoLogin() {
  const result = useMutation({
    mutationFn: () =>
      profileApi
        .get('api/profile/login', {
          searchParams: {
            redirectUrlOnSuccess: window.location.origin,
            redirectUrlOnFail: `${window.location.origin}/auth-failed`,
            mode: window.__CONFIG.VITE_BRANDING,
          },
        })
        .json<{ redirectUrl: string }>(),

    onSuccess: (data) => {
      window.location.href = data.redirectUrl;
    },

    onError: (error) => {
      // TODO: show toast with error message
      console.error(error);
    },
  });

  return result;
}

export default useSsoLogin;
